module.exports = __webpack_public_path__ + "img/icon_map_bs_c.4219fb2e.png";